/*
指定の文字列長になるようにテキストを省略する関数

@param text   省略したいテキスト
@param length 文字列長
*/
export function omitText(text: string, length: number): string {
  return text.length >= length ? text.slice(0, length) + "..." : text;
}
